<template>
  <!-- <div class="main"> -->
  <div :class="!context.debug.setupTasti ? 'main' : ''">
    <div v-if="context.helpEnabled" class="modal-help-ovelay" />
    <template v-if="!context.debug.setupTasti">
      <gruppo
        v-for="(gr, index) in gruppi"
        :key="index"
        :context="context"
        :zona="gr.zona"
        :tasti="isTastoVisible(gr)"
        @send-event="sendEvent"
      >
      </gruppo>
    </template>
    <template v-else>
      <configuratore-tasti
        :context="context"
        :gruppiTasti="gruppi"
        @send-event="sendEvent"
        :parametriLayout="parametriLayout"
      >
      </configuratore-tasti>
    </template>
    <scontrino-semplificato
      v-if="!context.debug.setupTasti"
      :context="context"
      @send-event="sendEvent"
    />
    <keyEvent
      :context="context"
      :resetBuffer="context.resetBuffer"
      :displayValue="context.displayValue"
      @send-event="sendEvent"
    />
    <modale
      :context="context"
      @send-event="sendEvent"
      @send-event-delay="sendEventWithDelay"
    />
    <popup :context="context" @send-event="sendEvent" />
    <errore-stampante
      :errore="context.erroreStampante"
      @send-event="sendEvent"
    />
    <toast-generico
      :message="context.messaggioToast"
      :confirm="context.confirmToast"
      :confirmObj="context.confirmToastObj"
      :raiseEvent="context.confirmRaiseEvent"
      @send-event="sendEvent"
    />
    <display :context="context" />
    <accesso :context="context" @send-event="sendEvent" />
  </div>
</template>

<script>
/* eslint-disable */
import { interpret } from "xstate";
import { dashboardMachine } from "@/machines/dashboardMachine.js";
import { dashboardMachine as dashboardMachineMultiazienda } from "@/machines/multiAzienda/dashboardMachine.js";
import logger from "@/services/loggerService.js";

import Gruppo from "@/components/gruppoTasti/GruppoToggle.vue";
// import GruppoEdit from '@/components/gruppoTasti/editor/GruppoEdit.vue'
import ConfiguratoreTasti from "@/components/gruppoTasti/editorNew/ConfiguratoreTasti.vue";

import ScontrinoSemplificato from "@/components/scontrino/ScontrinoSemplificato.vue";

import KeyEvent from "@/components/keyEvent/KeyEvent.vue";
import Modale from "@/components/modale/Modale.vue";
import Popup from "@/components/popup/Popup.vue";
import ErroreStampante from "@/components/erroreStampante/index.js";
import ToastGenerico from "@/components/toastGenerico/index.js";
import SimplePopupKeyboard from "@/components/popup/SimpleKeyboard";
import PopupListResult from "@/components/popup/ListResult";
import Display from "@/components/display";
import Accesso from "@/components/accesso";

import configurazioni from "@/services/configurazioniService.js";
import documenti from "@/services/documentiService.js";
/*   import prodotti from '@/services/prodottiService.js'
  import licenze from '@/services/licenzeService.js' */
import { verificaLicenza } from "@/mixins/verificaLicenza.js";
import { insomnia } from "@/mixins/insomnia.js";
import ordiniWH from "@/services/custom/ordiniWH";

export default {
  name: "layout02",
  components: {
    Keypress: () => import("vue-keypress"),
    Gruppo,
    // GruppoEdit,
    ConfiguratoreTasti,
    ScontrinoSemplificato,
    KeyEvent,
    Modale,
    Popup,
    ErroreStampante,
    ToastGenerico,
    SimplePopupKeyboard,
    PopupListResult,
    Display,
    Accesso
  },
  mixins: [verificaLicenza, insomnia],
  created() {
    const multiazienda = this.$store.getters.multiazienda;
    const dm = multiazienda ? dashboardMachineMultiazienda : dashboardMachine;
    this.displayService = interpret(dm);
    this.current = dm.initialState;
    this.context = dm.context;
    // Start service on component creation
    this.displayService
      .onTransition(state => {
        // console.log('change state: ', state)
        console.log(
          "change state: ",
          `${JSON.stringify(state.value)}  TYPE: ${
            state.event.type
          }    VALUE: ${JSON.stringify(state.event.value || {})}`,
          state
        );
        // Update the current state component data property with the next state
        this.current = state;
        // Update the context component data property with the updated context
        this.context = state.context;
        this.context.router = this.$router;

        // TODO: Rimettere per log operazioni
        if (
          state.context.impostazioni &&
          state.context.impostazioni.debug &&
          state.context.impostazioni.debug.log_state_change
        ) {
          logger.log(
            `${JSON.stringify(state.value)}  TYPE: ${
              state.event.type
            }    VALUE: ${JSON.stringify(state.event.value || {})}`,
            "layout",
            "info"
          );
        }

        if (state.context.reloadPage) {
          state.context.reloadPage = false;
          this.$router.go(0);
        }

        if (state.context.importDati) {
          state.context.importDati = false;
          this.$router.push("/import");
        }
        if (this.timeoutTimerID) {
          this.setupTimer();
        }
        // TEST VINCITA
        if (this.context.impostaVincita) {
          this.context.impostaVincita = false;
          setTimeout(() => {
            this.displayService.send("RICALCOLA_TOTALI");
          }, 500);
        }
      })
      .start();

    setTimeout(async () => {
      await this.cicleSyncProcess();
      const status = await this.getProcessStatus();
      this.$store.commit("SET_SERVICE_STATUS", status);
    }, 1000);
  },
  /*     beforeDestroy() { // TODO: Verificare se serve
      this.displayService.onTransition = null
      this.displayService = null
    }, */
  data() {
    return {
      displayService: null,
      current: null,
      context: null,
      configGruppi: [],
      parametriLayout: {},
      impostazioni: null,
      logger: null,
      token: "",
      timeoutTimerID: null,
      logOutTimeout: 0
    };
  },
  async mounted() {
    const layoutTasti = this.$store.getters.layoutTasti; // 'layout_02'
    await this.gestioneToken();
    this.context.runMode = await this.debugMode();
    this.context.scontrinoTick++;
    this.context.layoutTasti = layoutTasti;

    var result = await configurazioni.getConfigurazione("gruppi_tasti");
    let infoLayout = result[layoutTasti];

    // Eventuale template passato con la pagina. Deve essere usato solo come demo, altrimenti inserire su database
    const template = this.$route.params.template;
    if (template && result[`${layoutTasti}_${template}`]) {
      infoLayout = result[`${layoutTasti}_${template}`];
      this.$store.commit("SET_LAYOUT_TASTI", `${layoutTasti}_${template}`);
      this.context.layoutTasti = `${layoutTasti}_${template}`;
    }

    this.configGruppi = infoLayout.gruppi || [];
    let infoParametri = result.parametri;
    this.parametriLayout = infoParametri || {};

    result = await configurazioni.getConfigurazione("display_generale");
    this.context.impostazioni = result || {};
    result = await configurazioni.getConfigurazione("offerte", "elenco");
    this.context.offerte = result.errore ? [] : result;

    setTimeout(() => {
      this.context.listino = this.context.impostazioni.listini.base || "L1";
      if (
        !this.$store.getters["initialPrinterState"] &&
        !this.context.impostazioni.stampante.stampa_disabilitata
      ) {
        this.displayService.send("GET_INITIAL_PRINTER_STATUS");
        this.$store.commit("SET_INITIAL_PRINTER_STATUS_FLAG");
      }
    }, 200);
    const logoutMinuti = this.context.impostazioni.operatori.logoutMinuti || 0;
    if (logoutMinuti) {
      this.logOutTimeout = logoutMinuti * 60 * 1000;
      this.startTimer();
    }
    if (this.context.impostazioni.cassa.layout.startPage) {
      for (let sp of Object.keys(
        this.context.impostazioni.cassa.layout.startPage
      ))
        this.context.pageList[
          sp
        ] = this.context.impostazioni.cassa.layout.startPage[sp];
    }
    navigator.serviceWorker.addEventListener("message", async event => {
      // TODO: Gestire --> salvataggio su Park + stampa comanda
      console.log("Received a message from service worker: ", event.data);
      const impoWH = _.get(this.context.impostazioni, "webhook");
      const payload = event.data;
      switch (payload.data.eCommerceType) {
        case "custom":
          const impoCustom = impoWH ? impoWH.custom : null;
          const ordine = await ordiniWH.parseOrdineWH(event.data);
          if (impoCustom) {
            const postazione = configurazioni.getPostazione();
            const park = await ordiniWH.inviaOrdinePark(
              impoCustom,
              ordine,
              postazione
            );
            if (impoCustom.stampaComanda) {
              const event = {
                type: "STAMPA_COMANDA",
                payload: {
                  tipo: "park",
                  chiave: park._id
                }
              };
              this.sendEvent(event);
            }
          }
          break;
        case "woocommerce":
          const impoWoocommerce = impoWH ? impoWH.woocommerce : null;
          const ordineWC = await ordiniWH.parseOrdineWC(
            event.data,
            impoWoocommerce
          );
          if (impoWH) {
            const postazione = configurazioni.getPostazione();
            if (_.get(impoWoocommerce, "parcheggio.crea")) {
              const park = await ordiniWH.inviaOrdinePark(
                impoWoocommerce,
                ordineWC,
                postazione
              );
              this.sendEvent({ type: "NUOVO_ORDINE_PARK", value: true });
            }
            if (_.get(impoWoocommerce, "ordine.crea")) {
              // Crea ordineEC--> configurato come DDT --> Impegna la giacenza
              const ordine = await ordiniWH.wcCreaOrdineEC(
                impoWoocommerce,
                ordineWC,
                postazione
              );
            }
            console.log("ordine elaborato", ordineWC);
          }
          break;
        default:
          break;
      }
      this.context.numeroOrdiniWeb = String(
        parseInt(this.context.numeroOrdiniWeb) + 1
      );
      await documenti.confermaNotifica(payload.data.docId);
    });
  },
  methods: {
    startTimer() {
      this.timeoutTimerID = window.setTimeout(
        this.logoutUser,
        this.logOutTimeout
      );
    },
    setupTimer() {
      window.clearTimeout(this.timeoutTimerID);
      this.startTimer();
    },
    async logoutUser() {
      await this.gestioneToken();
      window.clearTimeout(this.timeoutTimerID);
      if (this.context.operatore) {
        const event = {
          type: "SELEZIONA_OPERATORE",
          value: {
            tipo: "servizio",
            item: null
          }
        };
        this.sendEvent(event);
      }
    },
    isTastoVisible(gr) {
      const pl = parseInt(this.context.pageList[gr.zona]);
      return gr.tasti.filter(
        x =>
          !x.page ||
          (x.page && Array.isArray(x.page) && x.page.includes(pl)) ||
          (x.page && !Array.isArray(x.page) && x.page === pl)
      );
      // return gr.tasti.filter(x => !x.page || x.page === context.pageList[gr.zona])
    },
    sendEvent(event) {
      this.displayService.send(event);
    },
    sendEventWithDelay(event) {
      // NON usato, aggiunto payload all'evento standard
      var self = this;
      var delay = event.delay;
      delete event.delay;
      setTimeout(() => {
        self.displayService.send(event);
      }, delay);
    }
  },
  computed: {
    gruppi() {
      return this.configGruppi.filter(x => !x.zona.startsWith("funzioni"));
    }
  }
};
</script>

<style lang="scss">
@import "./layout.scss";

.modal-help-ovelay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  background-color: #0000009c;
}
</style>
